import React, { Component } from 'react'
import { ReactSVG } from 'react-svg'
import { isMobile } from '../../classes/Platform.js'
import SpinnerShape from '../../assets/Spinners/SpinnerShape.svg'
import Back from '../../assets/Icons/Back.svg'
import Err from '../../assets/Icons/Alert.svg'
import './legacy.css'

export class UIIcon extends Component {
  render() {
    const { className, icon, onClick } = this.props
    return (
      <div className={className || 'uiIcon'} onClick={onClick}>
        <ReactSVG
          className={'uiIconSvg' + (className ? ` ${className}Svg` : '')}
          src={icon}
        />
      </div>
    )
  }
}

export class UIToggleButton extends Component {
  onChange = e => {
    e.preventDefault()
    this.props.onChange()
  }

  render() {
    let className = this.props.className ? `${this.props.className} uiToggleButton` : 'uiToggleButton'
    if (this.props.selected) {
      className += ` ${className}Selected`
    }

    return (
      <div className={className} onClick={this.onChange}>
        <div className='uiToggleButtonLabel'>{this.props.label}</div>
        <UIIcon icon={this.props.icon} />
      </div>
    )
  }
}

export class UIButton extends Component {
  render() {
    let className = 'uiButton'
    let iconClassName = 'uiButtonIcon'
    let labelClassName = 'uiButtonLabel'

    if (this.props.className) {
      if (this.props.extend) {
        className += ` ${this.props.className}`
      } else {
        className = this.props.className
        iconClassName = `${this.props.className}Icon`
        labelClassName = `${this.props.className}Label`
      }
    }

    if (this.props.selected) {
      className += ` ${className}Selected`
    }

    const { action } = this.props
    let onClick
    let onMouseDown

    if (isMobile()) {
      onClick = e => {
        const editing = this.props.editing ? this.props.editing() : !!document.activeElement
        if (!editing && action) action(e)
      }
      onMouseDown = e => {
        const editing = this.props.editing ? this.props.editing() : !!document.activeElement
        if (editing) {
          e.preventDefault()
          if (action) action(e)
        }
      }
    } else {
      onClick = e => {
        if (action) action(e)
      }
    }

    return (
      <div className={className} onClick={onClick} onMouseDown={onMouseDown}>
        <UIIcon className={iconClassName} icon={this.props.icon} />
        <div className={labelClassName}>{this.props.label}</div>
      </div>
    )
  }
}

export class UIOKCancel extends Component {
  state = {
    cancelBusy: false,
    okBusy: false
  }

  ok = () => {
    if (this.clicked) return Promise.resolve()
    this.clicked = true
    const block = !this.props.background
    this.setState({ okBusy: true })
    if (block) window.blockInput()

    const done = () => {
      this.clicked = false
      this.setState({ okBusy: false })
      if (block) {
        window.unblockInput()
        clearInterval(this.interval)
      }
    }

    let promise = this.props.ok()
    if (!promise || !promise.then) {
      promise = Promise.resolve()
    }

    promise.then(done).catch(err => {
      this.clicked = false
      console.error(err)
      this.setState({ error: true })
      done()
    })
  }

  cancel = () => {
    if (this.cancelClicked) return Promise.resolve()
    this.cancelClicked = true
    window.blockInput()
    this.setState({ cancelBusy: true })

    const done = () => {
      this.cancelClicked = false
      window.unblockInput()
      this.setState({ cancelBusy: false })
    }

    this.props.cancel().then(done).catch(err => {
      this.clicked = false
      console.error(err)
      this.setState({ error: true })
      done()
    })
  }

  resetError = () => {
    this.setState({ error: false })
  }

  componentWillUnmount() {
    if (this.state.busy) {
      window.unblockInput()
    }
  }

  componentDidUpdate(prevProps) {
    const block = !this.props.background
    if (!block) return
    if (this.props.lookBusy && !prevProps.lookBusy) {
      window.blockInput()
    } else if (!this.props.lookBusy && prevProps.lookBusy) {
      window.unblockInput()
    }
  }

  setRef = ref => {
    if (ref) this.ref = ref
  }

  render() {
    if (this.state.error || this.props.error) {
      return (
        <div className='uiOKCancel uiOKCancelWithOof'>
          <div className='uiOKCancelOof' onClick={this.props.onErrorClick || this.resetError}>
            <div className='uiOKCancelOofIcon'>
              <ReactSVG src={Err} />
            </div>
            <div className='uiOKCancelOofLabel'>Oof, Sorry that didn't work</div>
          </div>
        </div>
      )
    }

    const keepFocus = action => e => {
      e.preventDefault()
      action()
    }
    const busy = this.state.okBusy || this.props.lookBusy
    const cancelBusy = this.state.cancelBusy
    const onMouseDown = this.props.keepFocus ? keepFocus(this.ok) : null
    const onClick = this.props.keepFocus ? null : this.ok
    const onCancelMouseDown = this.props.keepFocus ? keepFocus(this.cancel) : null
    const onCancelClick = this.props.keepFocus ? null : this.cancel

    return (
      <div className='uiOKCancel' ref={this.setRef}>
        {this.props.back && (
          <div key='back' className='uiOKCancelBack' onClick={this.props.back}>
            <ReactSVG src={Back} />
          </div>
        )}
        {this.props.cancel && (
          <div key='cancel' className='uiOKCancelCancel' onClick={onCancelClick} onMouseDown={onCancelMouseDown}>
            <div className={'uiOKCancelCancelIcon' + (cancelBusy ? ' uiOKCancelBusy' : '')}>
              <ReactSVG src={cancelBusy ? SpinnerShape : this.props.cancelIcon} />
            </div>
          </div>
        )}
        {this.props.ok && (
          <div key='ok' className='uiOKCancelOK' onClick={onClick} onMouseDown={onMouseDown}>
            <div className={'uiOKCancelOKIcon' + (busy ? ' uiOKCancelBusy' : '')}>
              {this.props.okNode && !busy ? this.props.okNode : <ReactSVG src={busy ? SpinnerShape : this.props.okIcon} />}
            </div>
            <div className='uiOKCancelOKLabel'>{this.props.label}</div>
          </div>
        )}
      </div>
    )
  }
}
